import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './authInterceptor'; // N-100: глобальный перехватчик истёкшего токена (401/403 -> /login)
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import Patients from './pages/Patients';
import AddPatient from './pages/AddPatient';
import Clinics from './pages/Clinics';
import Commissions from './pages/Commissions';
import Profile from './pages/Profile';
import Help from './pages/Help';
import Support from './pages/Support';
import Notifications from './pages/Notifications';
import AdminSession from './pages/AdminSession';

function App() {
  // N-125: сессия impersonation живёт в sessionStorage (см. AdminSession.js) — проверяем
  // её первой, иначе после редиректа на /dashboard (полная перезагрузка страницы) гард
  // не нашёл бы токен и вернул impersonation-вкладку на /login.
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  const guard = (el) => (token ? el : <Navigate to="/login" />);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/admin-session" element={<AdminSession />} />
        <Route path="/dashboard" element={guard(<Dashboard />)} />
        <Route path="/patients" element={guard(<Patients />)} />
        <Route path="/patients/add" element={guard(<AddPatient />)} />
        <Route path="/clinics" element={guard(<Clinics />)} />
        <Route path="/commissions" element={guard(<Commissions />)} />
        <Route path="/profile" element={guard(<Profile />)} />
        <Route path="/help" element={guard(<Help />)} />
        <Route path="/support" element={guard(<Support />)} />
        <Route path="/notifications" element={guard(<Notifications />)} />
        <Route path="*" element={<Navigate to={token ? '/dashboard' : '/login'} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
